import React from 'react'
import './Withdrawrecord.css'
const Withdrawrecord = () => {
  return (
    <>
    
    
    <div className='main-with-record'>

        <div className='main-content-with'>
            <div className='time-div'>
                <div>
                    <p className='gray-p'>point</p>
                    <p className='black-p'>₹83.00</p>
                </div>
                <div>
                    <p className='gray-p'>Time</p>
                    <p className='black-p'>03/11 00:56</p>
                </div>
                <div>
                    <p className='gray-p'>State</p>
                    <p className='green-p'>Completed</p>
                </div>
            </div>
            <div className='acually'>
                <div>
                    <p className='gray-p'>Acually arrived:31</p>
                    <p className='gray-p'>Asima maity</p>
                    <p className='gray-p'>sounvmaity2017@ndjfbank</p>
                </div>
                 <div><p className='gray-p'>Free:0</p></div>
            </div>
        </div>
    </div>
    
    
    
    </>
  )
}

export default Withdrawrecord